import { Component, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ActivatedRoute } from '@angular/router';
import { ProductDetailComponent } from '@vendure/admin-ui/catalog';
import {
  CustomDetailComponent,
  NotificationService,
  SharedModule,
} from '@vendure/admin-ui/core';
import { Product } from '@vendure/core';
import {
  Observable,
  asapScheduler,
  distinctUntilChanged,
  filter,
  map,
  pairwise,
  scheduled,
  withLatestFrom,
} from 'rxjs';

@Component({
  template: ``,
  standalone: true,
  providers: [],
  imports: [SharedModule],
})
export class ProductDetailFormListenerComponent
  implements CustomDetailComponent
{
  entity$!: Observable<Product>;

  private readonly productDetailComponent = inject(ProductDetailComponent);

  detailForm = this.productDetailComponent.detailForm;

  constructor() {
    const notificationService = inject(NotificationService);
    const route = inject(ActivatedRoute);

    const languageCodeFromUrl$ = route.paramMap.pipe(
      map((paramMap) => paramMap.get('lang')),
      distinctUntilChanged(),
    );

    const slugChangedDueToSave$ = scheduled(
      this.detailForm.controls.slug.valueChanges.pipe(distinctUntilChanged()),
      asapScheduler,
    ).pipe(
      withLatestFrom(languageCodeFromUrl$),
      pairwise(),
      filter(
        ([[oldVal, oldLangFromUrl], [newVal, newLangFromUrl]]) =>
          this.detailForm.pristine &&
          oldVal !== newVal &&
          oldLangFromUrl === newLangFromUrl,
      ),
    );

    slugChangedDueToSave$
      .pipe(takeUntilDestroyed())
      .subscribe(([[inputSlug], [updatedSlug, newLangFromUrl]]) => {
        notificationService.warning(
          `Slug ${inputSlug} not unique in Language ${newLangFromUrl}! Changed to ${updatedSlug}`,
        );
      });
  }
}
